// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserReview_wrapper__UJMe2","stars":"UserReview_stars__1x32H","review":"UserReview_review__bjMmy"};